export const MASKS = {
  PHONE: '(999) 999-9999',
  BUSINESS_PHONE: '(999) 999-9999 x9999',
  LOAN_GUID: '********-****-****-****-************'
}
